import React from "react";
import { IStory } from "../../../store/services/invitations/dto/invitations.dto";
import { Box, Button, TextField, Divider, IconButton } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";
import { StoryWrapper } from "./styles";
import { cloneDeep } from "lodash";
import { LTR } from "../../Templates/WeddingTemplates/constants";

const NEW_SOCIAL = {
	title: "",
	description: ""
};
const MAX_STORIES = 5;
const Story = ({
	fieldValueState,
	setFieldValueState,
	dir
}: {
	fieldValueState: IStory[];
	setFieldValueState: React.Dispatch<React.SetStateAction<IStory[]>>;
	dir?: string;
}) => {
	const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
		setFieldValueState(prevState => {
			const oldList = cloneDeep(prevState);
			const index = oldList.findIndex(o => o._id === id);
			oldList[index].title = e.target.value;
			return oldList;
		});
	};

	const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
		setFieldValueState(prevState => {
			const oldList = cloneDeep(prevState);
			const index = oldList.findIndex(o => o._id === id);
			oldList[index].description = e.target.value;
			return oldList;
		});
	};

	const handleAddNewStory = () => {
		setFieldValueState(prevState => [...prevState, { ...NEW_SOCIAL, _id: uuidv4() }] as IStory[]);
	};

	const handleDeleteStory = (id: string) => {
		setFieldValueState(prevState => [...prevState].filter(item => item._id !== id));
	};

	return (
		<StoryWrapper>
			{fieldValueState.map((story, index) => (
				<Box key={story._id} display={"flex"} flexDirection={"column"} mb={4} gap={2} position={"relative"}>
					<IconButton onClick={() => handleDeleteStory(story._id)} className={"delete_icon"}>
						<Delete />
					</IconButton>
					<Box width={"100%"} dir={dir}>
						<TextField
							fullWidth
							label={dir === LTR ? "Title" : "العنوان"}
							value={story.title}
							placeholder={"Title"}
							onChange={e => handleTitleChange(e, story._id)}
						/>
					</Box>
					<Box width={"100%"} dir={dir}>
						<TextField
							multiline
							rows={5}
							fullWidth
							label={dir === LTR ? "Description" : "الوصف"}
							value={story.description}
							placeholder={"Description"}
							onChange={e => handleDescriptionChange(e, story._id)}
						/>
					</Box>
					{fieldValueState.length - 1 !== index && (
						<Box my={1}>
							<Divider />
						</Box>
					)}
				</Box>
			))}
			<Box my={3}>
				<Button
					variant={"outlined"}
					color={"primary"}
					onClick={handleAddNewStory}
					fullWidth
					disabled={MAX_STORIES === fieldValueState.length}
				>
					<Add />
				</Button>
			</Box>
		</StoryWrapper>
	);
};

export default Story;
